const body = document.querySelector("body"),
    nav = document.querySelector(".js-main-nav"),
    navToggle = document.querySelectorAll(".js-nav-toggle");

export function init() {
    navToggle.forEach((btn) => {
        btn.addEventListener("click", function () {
            if (body.classList.contains("nav-showing")) {
                hideNav();
            } else {
                showNav();
            }
        });
    });
}

function showNav() {
    body.classList.add("nav-showing", "overflow-hidden");
    nav.classList.add("-translate-x-full");

    // Focus first item in menu
    nav.querySelector(".js-main-nav-focus-target").focus();
}

function hideNav() {
    body.classList.remove("nav-showing", "overflow-hidden");
    nav.classList.remove("-translate-x-full");
}
